import xhr from '../xhr/'
import store from 'store'

class CommonService {

  getjsonp ({ body } = {}) {
    if(window.__wxjs_environment === 'miniprogram') {//统一加参数
      body.f = '2'
    } else {
      body.f = '1'
    }
    let unionId = store.get("global_unionid")
    if(unionId) {
      body.u = unionId
    }else{
      body.u =1
    }
    return xhr({ url: '/h5/getjsonp', body: body })
  }

}

// 实例化后再导出
export default new CommonService()
